import { FC, useCallback } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import { BUTTON_TITLE } from '~/constants/main';
import { history } from '~/services/history';
import { scrollToErrorElement } from '~/utils/helpers';

interface IProps {
  redirectPath?: string;
  setValidation?: () => boolean;
  onSubmit: () => Promise<true | undefined>;
  onReset?: () => void;
}

const SettingControlsBlock: FC<IProps> = ({ redirectPath, setValidation, onSubmit, onReset }: IProps): JSX.Element => {
  const submitHandler = useCallback(async () => {
    const isValid: boolean = typeof setValidation === 'function' ? setValidation() : true;

    if (!isValid) {
      scrollToErrorElement();
      return;
    }

    const successSubmit: boolean | undefined = await onSubmit();
    if (successSubmit && redirectPath) history.push(redirectPath);
  }, []);

  return (
    <div className="d-flex flex-row mt-2 gap-10">
      <Button title={localeStore.t(BUTTON_TITLE.SAVE)} onClick={submitHandler} />
      {typeof onReset === 'function' ? <Button title={localeStore.t(BUTTON_TITLE.RESET)} onClick={onReset} appearance="tertiary" /> : null}
    </div>
  );
};

export default SettingControlsBlock;
